import { TOptions } from 'i18next'
import { useTranslation as translation } from 'react-i18next'
import { TxKeyPath } from '@i18n'

export const useTranslation = function () {
  const { t } = translation<TxKeyPath>()

  const translate = (key: TxKeyPath, options?: TOptions) => {
    return t(key, options)
  }

  return { translate }
}
